import React from 'react';
import { Card, CardGroup } from '@douyinfe/semi-ui';
import { Divider } from '@douyinfe/semi-ui';
import { Typography } from '@douyinfe/semi-ui';

const { Meta } = Card;
const { Title } = Typography;

export interface IAppLink {
    name: string;
    href: string;
    iconPath: string;
    isFrequent: boolean;
};

export const links: IAppLink[] = [
    {
        name: "用友U9 (内网)",
        href: "/erp",
        iconPath: "u9.jpeg",
        isFrequent: true,
    }, {
        name: "用友U9 (VPN)",
        href: "/erp_vpn",
        iconPath: "u9.jpeg",
        isFrequent: true,
    }, {
        name: "Glaw (内网)",
        href: "/openclaw",
        iconPath: "claw.png",
        isFrequent: true,
    }, {
        name: "Glaw (VPN)",
        href: "/openclaw_vpn",
        iconPath: "claw.png",
        isFrequent: true,
    }, {
        name: "易签宝",
        href: "https://web.esign.cn/workspace/home",
        iconPath: "esign.jpeg",
        isFrequent: true,
    }, {
        name: "新核云",
        href: "https://c2.xinheyun.com/newcore/login/",
        iconPath: "xhy.jpeg",
        isFrequent: false,
    }, {
        name: "阿里企业邮箱",
        href: "http://mail.gwell.cn/",
        iconPath: "alimail.jpeg",
        isFrequent: false,
    },
];

export const AppLink = (props: any) => {
    const size = props.size || 115;
    const margin = props.margin || 15;

    return <a href={props.link.href} rel="noreferrer" target='_blank'>
        <Card
            cover={
                <img
                    alt={props.link.name}
                    src={`/assets/apps/${props.link.iconPath}`}
                    height={size + margin}
                    width={size + margin}
                    style={{
                        maxHeight: size,
                        maxWidth: size,
                        margin: margin,
                    }}
                />
            }
        >
            <Meta title={props.link.name} />
        </Card>
    </a>;
};

const Apps = () =>
    <>
        <Title heading={2}  >全部APP</Title>
        <Divider margin='25px' />
        <CardGroup>
            {links.map((link) => <AppLink link={link} />)}
        </CardGroup>
    </>;

export default Apps;
